import { useRef, type CSSProperties, type ReactNode } from 'react';

/** Så länge man håller in Q-knappen innan Q börjar lyssna direkt. */
export const LONG_PRESS_MS = 450;

/**
 * Q-knappen i toppraden: ett tryck öppnar panelen, ett långt tryck öppnar den och börjar lyssna.
 * Utseendet bestäms av den som använder knappen (HomeBar och TopNav ser olika ut).
 */
export function QButton({ onOpen, style, children, title = 'Q' }: {
  onOpen: (listen: boolean) => void;
  style: CSSProperties;
  children: ReactNode;
  title?: string;
}) {
  const timer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);
  const longFired = useRef(false);

  const clear = () => { clearTimeout(timer.current); timer.current = undefined; };

  return (
    <button
      type="button"
      aria-label={title}
      title={title}
      style={{ ...style, touchAction: 'manipulation', WebkitUserSelect: 'none', userSelect: 'none', WebkitTouchCallout: 'none' }}
      onPointerDown={e => {
        if (e.button !== 0) return;
        longFired.current = false;
        clear();
        timer.current = setTimeout(() => { longFired.current = true; timer.current = undefined; onOpen(true); }, LONG_PRESS_MS);
      }}
      onPointerUp={clear}
      onPointerLeave={clear}
      onPointerCancel={clear}
      onContextMenu={e => e.preventDefault()}
      onClick={() => {
        clear();
        if (longFired.current) { longFired.current = false; return; }
        onOpen(false);
      }}
    >
      {children}
    </button>
  );
}
